import React, { useCallback, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Card, Button, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import playBtn from "../image/musicModal/play-white.png";
import stopBtn from "../image/musicModal/stop-white.png";
import "../style/MusicPlayer.css";
import { setVolume, setPlaying, setLoop } from "../Redux/action";
import noloop from "../image/musicModal/noloop2.png";
import loop1 from "../image/musicModal/loop2.png";
const MusicPlayer = () => {
  const dispatch = useDispatch();
  const progress = useSelector((state) => state.audio.progress);
  const volume = useSelector((state) => state.audio.volume);
  const playing = useSelector((state) => state.audio.playing);
  const audio = useSelector((state) => state.audio.audio);
  const loop = useSelector((state) => state.audio.loop);
   const localization = useSelector((state) => state.localization.localization);
  
  useEffect(() => {
    console.log("Volume:", volume);
    console.log("Playing:", playing);
    console.log("Loop:", loop);
    console.log("audio:", audio);
  }, [volume, playing, loop]);

  const handleVolumeChange = (e) => {
    const newVolume = Math.min(Math.max(e.target.value, 0), 100); // Clamp between 0 and 100
    dispatch(setVolume(newVolume));
    if (audio) {
      audio.volume = newVolume / 100; // Volume as a fraction
    }
  };

  const increaseVolume = () => {
    const newVolume = Math.min(volume + 5, 100);
    dispatch(setVolume(newVolume));
    if (audio) {
      audio.volume = newVolume / 100;
    }
  };

  const decreaseVolume = () => {
    const newVolume = Math.max(volume - 5, 0);
    dispatch(setVolume(newVolume));
    if (audio) {
      audio.volume = newVolume / 100;
    }
  };

  // const handlePlayPause = useCallback(() => {
  //   console.log('handlePlayPause called');
  //   if (playing) {
  //     audio?.pause();
  //     dispatch(setPlaying(false));
  //   } else {
  //     audio?.play();
  //     dispatch(setPlaying(true));
  //   }
  // }, [playing, audio, dispatch]);

  // Separate play and pause functions
  const handlePlay = useCallback(() => {
    console.log("handlePlay called");
    audio?.play();
    dispatch(setPlaying(true));
  }, [audio, dispatch]);

  const handlePause = useCallback(() => {
    console.log("handlePause called");
    if (audio ) {
        audio.pause();
        dispatch(setPlaying(false));
        console.log("Audio paused");
    } else {
        console.log("Audio is already paused or not defined.");
    }
}, [audio, dispatch]);

  const handleLoopToggle = () => {
    const newLoopState = !loop;
    if (audio?.loop !== newLoopState) {
      dispatch(setLoop(newLoopState)); // Toggle the loop state
      audio.loop = newLoopState; // Set the audio element's loop property
    }
  };

  return (
    <Card.Body className="d-block music-player text-white">
      <div className="main-part">
        <div className="d-flex h-100">
          <div className="audiobtnplaypause w-25">
            <img
              src={playing ? stopBtn : playBtn}
              className="img-fluid"
              style={{ width: "45px", height: "35px" }}
              alt={playing ? "stopBtn" : "playBtn"}
              onClick={playing ? handlePause : handlePlay}
            />
          </div>
          <div className="audiobtnplaypause-second w-75">
            <span>{localization.theme_song}</span>
            <Form.Range
              value={progress}
              // onChange={handleProgressChange}
              className="form-range"
              style={{ width: "90%" }}
            />
            <img
              src={loop ? loop1 : noloop}
              alt="no loop img"
              onClick={handleLoopToggle} // Use the function directly instead of an inline arrow function
            />
          </div>
        </div>
      </div>

      <div className="sub-part">
        <div className="volumeplusminusmaindiv">
          <Button
            variant="link"
            className="volumeplusmiusclass text-white p-0 text-decoration-none"
            onClick={increaseVolume}
            style={{ top: "5px", fontSize: "15px", fontWeight: 900 }}
          >
            +
          </Button>

          <Form.Range
            min={0}
            max={100}
            value={volume}
            onChange={handleVolumeChange}
            className="inputclassrange volumesliderr form-range-two"
          />

          <Button
            variant="link"
            className="volumeplusmiusclass text-white p-0"
            onClick={decreaseVolume}
          >
            _
          </Button>
        </div>
      </div>
    </Card.Body>
  );
};

export default MusicPlayer;
